import styled, { css } from 'styled-components'

export const PolicyContent = styled.div`
  padding: 0 4px 12px;
  font-size: 14px;
  line-height: 1.75;
  color: ${({ theme }) => theme.colors.black};
  text-align: ${({ theme }) => theme.rtl ? 'right' : 'left'};
  direction: ${({ theme }) => theme.rtl ? 'rtl' : 'ltr'};
  word-break: break-word;
  overflow-wrap: anywhere;

  p {
    margin: 0 0 12px;
  }

  ol, ul {
    margin: 0 0 14px;
    ${({ theme }) => theme.rtl ? css`
      padding-right: 22px;
      padding-left: 0;
    ` : css`
      padding-left: 22px;
      padding-right: 0;
    `}
  }

  li {
    margin-bottom: 10px;
  }

  li p {
    margin: 0 0 8px;
  }

  ul ul, ol ul, ul ol, ol ol {
    margin-top: 8px;
    margin-bottom: 8px;
  }

  strong {
    color: ${({ theme }) => theme.colors.primaryButtCol};
  }
`

export const PolicyLoading = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px 0;
`
